import gql from 'graphql-tag';

export const GET_BILLING_VISIT_SUMMARY = gql`
  query GetBillingVisitSummary($accountNumber: String!, $allEncounters: Boolean) {
    guarantor {
      encounters(accountNumber: $accountNumber, allEncounters: $allEncounters) {
        id
        fullAccountNumber
        billingDescription
        balance
        paymentPlan
        claims {
          cernerClaimNumber
          claimGeneratedDate
          planSubscriberId
        }
      }
    }
  }
`;
